import React from 'react';
import { reduxForm } from 'redux-form';
import { compose } from 'redux';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import {
    Title,
    Container,
    ButtonGroup,
    MultipleGroupFull,
    OnSubmitValidator
} from '../../containers/DefaultStyles/FormDetails';
import { LoadingSpinner } from '../../components/LoadingSpinner';

import ReactGoogleAutocomplete from '../InputFields/GoogleMapsAddressField';
import Button from '../Button';
import TwoGroup from '../TwoGroup';

import validate from './validations';

import submissionErrorHandler from '../../utils/submissionErrorHandler';

class FindPollingStationForm extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            valid: false,
            errors: submissionErrorHandler(props.currentFormValues, validate)
        };
        this.clearSubmitErrors = this.clearSubmitErrors.bind(this);
    }

    componentDidMount() {
        this.setState({ errors: [] });
    }

    setValidState(bool) {
        this.setState({ valid: bool });
    }

    setSubmitErrors(errors) {
        this.setState({ errors });
    }

    checkForBlurError(name) {
        const errors = submissionErrorHandler(this.props.currentFormValues, validate);
        if (errors.includes(name) && !this.state.errors.includes(name))
            this.setState({ errors: [...this.state.errors, name] });
    }

    clearSubmitErrors(fieldName) {
        if (fieldName && this.state.errors.includes(fieldName)) {
            this.setState({ errors: this.state.errors.filter(e => e !== fieldName) });
        }
    }

    render() {
        return (
            <Container autocomplete="on" onSubmit={this.props.handleSubmit}>
                <Title>Address Lookup</Title>
                <MultipleGroupFull>
                    <ReactGoogleAutocomplete
                        onBlur={() => this.checkForBlurError('address')}
                        submissionError={this.state.errors.includes('address')}
                        clearSubmitErrors={this.clearSubmitErrors}
                        formName={['findPollingStationForm', 'google_autocomplete']}
                        fields={['address_components', 'formatted_address']}
                        types={['address']}
                        componentRestrictions={{ country: 'US' }}
                        setValidState={this.setValidState.bind(this)}
                    />
                </MultipleGroupFull>
                <ButtonGroup
                    style={{
                        marginTop: '10px'
                    }}
                    isAddressSubmitting={this.props.isAddressSubmitting}
                >
                    <TwoGroup>
                        <Button label="Back" onClick={this.props.onBack} />
                        <OnSubmitValidator
                            onClick={e => {
                                e.preventDefault();
                                const errors = submissionErrorHandler(
                                    this.props.currentFormValues,
                                    validate
                                );

                                if (errors.length === 0 && !this.props.invalid && this.state.valid) {
                                    this.props.handleSubmit();
                                } else {
                                    this.setSubmitErrors(errors);
                                }
                            }}
                        >
                            <Button
                                primary={true}
                                type="submit"
                                label="Continue"
                                className="submitButton"
                                disabled={this.props.invalid || !this.state.valid}
                            />
                        </OnSubmitValidator>
                        <LoadingSpinner />
                    </TwoGroup>
                </ButtonGroup>
            </Container>
        );
    }
}

FindPollingStationForm.propTypes = {
    onBack: PropTypes.func,
    invalid: PropTypes.bool.isRequired,
    handleSubmit: PropTypes.func,
    isAddressSubmitting: PropTypes.bool,
    currentFormValues: PropTypes.object
};

export default compose(
    connect(state => ({
        initialValues: {
            address: state.cachedFormData.address || ''
        },
        currentFormValues: (state.form['findPollingStationForm'] || {}).values
    })),
    reduxForm({
        form: 'findPollingStationForm',
        destroyOnUnmount: false,
        validate
    })
)(FindPollingStationForm);
